import { useBoard } from "./BoardContext";
import { useOthers } from "./hooks";
import { useBoardUI } from "./store";

/** Remote cursors and drag ghosts, drawn inside the world so they follow the camera; scaled back so they keep screen size. */
export function Presence() {
  const { handle } = useBoard();
  const others = useOthers(handle.provider.awareness!);
  const z = useBoardUI((s) => s.camera.z);
  return (
    <>
      {[...others.entries()].map(([cid, st]) => (
        <div key={cid}>
          {st.pointer ? (
            <div
              className="pointer-events-none absolute left-0 top-0 transition-transform duration-75"
              style={{
                transform: `translate(${st.pointer.x}px, ${st.pointer.y}px) scale(${1 / z})`,
                transformOrigin: "0 0",
                zIndex: 1000,
              }}
            >
              <svg width="18" height="22" viewBox="0 0 18 22" aria-hidden>
                <path
                  d="M1 1 L17 10 L9 12 L5 21 Z"
                  fill={st.user?.color ?? "#fff"}
                  stroke="#000"
                  strokeWidth="1"
                />
              </svg>
              <span
                className="ml-3 whitespace-nowrap rounded-sm px-1.5 py-0.5 text-[11px] font-semibold text-black"
                style={{ background: st.user?.color ?? "#fff" }}
              >
                {st.user?.name}
              </span>
            </div>
          ) : null}
          {st.dragging?.map((d) => (
            <div
              key={d.id}
              className="pointer-events-none absolute left-0 top-0 rounded-[2px] border-2 border-dashed opacity-60"
              style={{
                transform: `translate(${d.x}px, ${d.y}px)`,
                borderColor: st.user?.color ?? "#fff",
                width: 120,
                height: 60,
              }}
            />
          ))}
        </div>
      ))}
    </>
  );
}

export function PresenceAvatars() {
  const { handle } = useBoard();
  const others = useOthers(handle.provider.awareness!);
  const unique = new Map<string, { name: string; color: string }>();
  for (const st of others.values()) if (st.user) unique.set(st.user.id, st.user);
  if (unique.size === 0) return null;
  return (
    <div className="flex -space-x-2">
      {[...unique.values()].slice(0, 6).map((u) => (
        <span
          key={u.name}
          title={u.name}
          className="flex size-7 items-center justify-center rounded-full border-2 border-panel text-[11px] font-bold text-black"
          style={{ background: u.color }}
        >
          {u.name.trim()[0]?.toUpperCase()}
        </span>
      ))}
      {unique.size > 6 ? (
        <span className="flex size-7 items-center justify-center rounded-full border-2 border-panel bg-panel-3 text-[11px]">
          +{unique.size - 6}
        </span>
      ) : null}
    </div>
  );
}
